<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Claim QR Code</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <p>Enter the printed short hash shown on the QR code you want to claim for this asset.</p>

  <form (submit)="onClaim()" (keydown.enter)="onClaim()" #form="ngForm">
    <mat-form-field class="full-width mb-0" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Short Hash</mat-label>
      <input
        matInput
        [(ngModel)]="paper_id"
        name="paper_id"
        type="text"
        maxlength="32"
        placeholder="e.g. C4CA4238"
        required/>
    </mat-form-field>
  </form>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="px-3 py-2">
  <button
    class="my-2 ml-1 mr-2"
    type="button"
    mat-raised-button
    color="primary"
    (click)="onClaim()"
    [disabled]="form?.invalid">
    Claim
  </button>
</mat-dialog-actions>
